<template>
  <div class="tree-options">
    <div class="tree-options__option">
      <div
        v-if="showInput"
        class="tree-options__wrapper"
        :class="{ 'tree-options__wrapper_active': selected }"
      >
        <div
          :class="{
            'tree-options__checkbox': !useRadio,
            'tree-options__checkbox--active': !useRadio && selected,
            'tree-options__radio': useRadio,
            'tree-options__radio--active': useRadio && selected
          }"
        >
          <OkArrowIcon v-if="!useRadio && selected" />
        </div>
        <input
          class="tree-options__input"
          :type="useRadio ? 'radio' : 'checkbox'"
          :value="selected"
          @click="!selected ? setOption() : unsetOption()"
        />
      </div>
      <div
        class="tree-options__name"
        :class="{ 'tree-options__name--active': selected }"
        @click="!selected ? setOption() : unsetOption()"
      >
        {{ option[nameKey] }}
      </div>
      <div
        v-if="option[childrenKey] && option[childrenKey].length"
        class="tree-options__dropdown-icon"
        :class="{ 'tree-options__dropdown-icon_active': isOpen }"
        @click="isOpen = !isOpen"
      >
        <div class="tree-options__dropdown-click-container" />
        <DropdownIcon />
      </div>
    </div>
    <div v-if="option[childrenKey] && isOpen" class="tree-options__column">
      <tree-options
        v-for="item in option[childrenKey]"
        :key="item[idKey] + item[nameKey]"
        :value="value"
        :option="item"
        :parent-value="!!selected"
        :only-children="onlyChildren"
        :use-radio="useRadio"
        @optionSelected="propagateSelected"
        @optionDeselected="propagateDeselected"
      />
    </div>
  </div>
</template>

<script>
import OkArrowIcon from '@/components/Icons/OkArrowIcon.vue';
import DropdownIcon from '@/components/Icons/DropdownIcon.vue';
export default {
  name: 'TreeOptions',
  components: {
    OkArrowIcon,
    DropdownIcon
  },
  props: {
    option: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    parentValue: {
      type: Boolean,
      default: false
    },
    onlyChildren: {
      type: Boolean,
      default: false
    },
    useRadio: {
      type: Boolean,
      default: false
    },
    idKey: {
      type: String,
      default: 'id'
    },
    nameKey: {
      type: String,
      default: 'name'
    },
    childrenKey: {
      type: String,
      default: 'children'
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    selected() {
      return this.value.find(
        option =>
          option[this.idKey] === this.option[this.idKey] &&
          option[this.nameKey] === this.option[this.nameKey]
      );
    },
    showInput() {
      return (
        !this.onlyChildren ||
        (this.onlyChildren &&
          (!this.option[this.childrenKey] || !this.option[this.childrenKey].length))
      );
    }
  },
  methods: {
    setOption() {
      if (this.showInput) {
        this.$emit('optionSelected', this.option);
        if (!this.onlyChildren && this.option[this.childrenKey].length) {
          this.isOpen = true;
        }
      } else {
        this.isOpen = !this.isOpen;
      }
    },
    unsetOption() {
      if (this.showInput && !this.useRadio) {
        this.$emit('optionDeselected', this.option);
      }
    },
    propagateSelected(value) {
      this.$emit('optionSelected', value);
    },
    propagateDeselected(value) {
      this.$emit('optionDeselected', value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.tree-options {
  @include uiFont;

  &__column {
    margin-left: 20px;
  }

  &__option {
    display: flex;
    margin-bottom: 16px;
    align-items: center;
  }

  &__input {
    position: absolute;
    opacity: 0;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }

  &__radio {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: thin solid $ui-gray-less-contrast;
    background-color: transparent;

    &--active {
      border-color: $ui-blue-accident;

      &::after {
        position: absolute;
        content: ' ';
        left: 4px;
        top: 4px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: $ui-blue-accident;
      }
    }
  }

  &__checkbox {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    border: thin solid #ceced6;
    background-color: transparent;

    &--active {
      border-color: $ui-blue-accident;
      background-color: $ui-blue-accident;

      &::v-deep svg {
        position: absolute;
        left: 4px;
        top: 5px;
      }
    }
  }

  &__wrapper {
    position: relative;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    flex: 0 0 16px;
  }

  &__dropdown-click-container {
    position: absolute;
    z-index: 1;
    width: 24px;
    height: 24px;
    background-color: transparent;
  }

  &__dropdown-icon {
    position: relative;
    cursor: pointer;
    transition: 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;

    &_active {
      transform: rotate(180deg);
    }
  }

  &__icon {
    margin: auto;
    width: 9px;
    height: 7px;

    svg {
      display: block;
      transform: translateY(1px);
    }
  }

  &__name {
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.3px;
    color: #2b2d34;
    margin-right: 8px;
    cursor: pointer;

    &--active {
      color: #6979f8;
    }
  }
}
</style>
